// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"72433b63","703":"fea5afdf","787":"4ee7b652"}[chunkId] + ".chunk.js";
};